import {eventsSlice} from './slice';

export * from './actions';
export * from './selectors';
export * from './slice';

export default eventsSlice.reducer;
